import React from 'react';
import moment from 'moment';
import styles from './HistoricalRiskDashboardFilter.module.scss';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import PropTypes from 'prop-types';
import { DateBox, SelectBox, TextBox } from 'devextreme-react';
import { isEmpty } from '../../util/functions';
import { datePattern, systemAckedTypes } from '../../util/constants';
import { filterDatePattern } from '../../util/orderFilterConstants';

const current = moment();

class HistoricalRiskDashboardFilter extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      historicDate: null,
      errorMsg: null
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleChange (event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSearch () {
    let errorMsg;
    if (this.state.historicDate === null) {
      errorMsg = 'Please select Date';
    }
    this.setState({ errorMsg: errorMsg });
    if (!errorMsg) {
      this.handleSubmit('search');
    }
  }

  handleSubmit (type) {
    let queryParam = {};
    queryParam.mpid = this.state.mpid;
    queryParam.date = this.state.historicDateFormat;
    queryParam.systemAcked = this.state.systemAcked;

    this.props.search(queryParam, type);
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.handleSubmit('search');
    };
  }

  handleDateChange (event, name) {
    // console.log(event.value);
    //  console.log(name);
    let val = event.value;
    this.setState({
      historicDate: val,
      historicDateFormat: val ? moment(val).format(datePattern) : null

    });
  }

  render () {
    const errorMsg = this.state.errorMsg;
    return (
      <div id='historicalRiskDashboardFilter' className={styles.container}>
        <div className={styles.formContainer}>

          <div className={styles.riskFilterGridStyle} onKeyDown={this.handleKeyDown}>

            <div key={'dateKey'}><Label title='Date' />
              <DateBox
                name={'historicDate'}
                value={this.state.historicDate}
                placeholder={'MM/DD/YYYY'}
                useMaskBehavior
                openOnFieldClick
                max={current}
                onValueChanged={this.handleDateChange}
                displayFormat={filterDatePattern} />
            </div>

            <div key={'mpidKey'}>
              <Label title='MPID' />
              <TextBox
                name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
                valueChangeEvent='keyup'
                onValueChanged={(e) => this.handleChange(e, 'mpid')} />

            </div>
            <div key={'systemAckedKey'}>
              <Label title='Resolved' />
              <SelectBox id={'systemAcked'}
                dataSource={systemAckedTypes}
                showClearButton
                placeholder={'Resolved'}
                value={this.state['systemAcked']}
                displayExpr='value'
                valueExpr='id'
                name={'systemAcked'}
                onValueChanged={(e) => this.handleChange(e, 'systemAcked')} />
            </div>
            <div id='applyButtonDiv' className={styles.applyButton}> <Button title='Apply' onClick={this.handleSearch} size='extraSmall' /></div>

          </div>
          {errorMsg && <div className={styles.errorMessages}>{errorMsg}</div>}

        </div>
      </div>
    );
  }
}
export default HistoricalRiskDashboardFilter;

HistoricalRiskDashboardFilter.propTypes = {
  search: PropTypes.func
};
